import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from "react";
import "./influencer-modal.scss";
import { Modal, ModalBody } from "components/modal";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "hooks/query";
import { InfluencerDiscoveryType } from "types";
import { Moment } from "moment";
import moment from "moment";

function InfluencerModal({
    open,
    setOpen,
    influencers,
    influencerIds,
    setInfluencerIds,
    streamIdList,
}: {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    influencers: InfluencerDiscoveryType[];
    influencerIds: number[];
    streamIdList: number[];
    setInfluencerIds: Dispatch<SetStateAction<number[]>>;
}) {
    const history = useHistory();
    const params = useParams<any>();
    const query = useQuery();

    const getStreamIcon = (id: number) => {
        return (
            {
                7: <i className="fab fa-x-twitter"></i>,
                8: <i className="fab fa-facebook"></i>,
                9: <i className="fab fa-instagram"></i>,
                10: <i className="fab fa-youtube"></i>,
                11: <i className="fab fa-linkedin"></i>,
            }[id] || <i></i>
        );
    };

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (influencerIds.includes(parseInt(e.currentTarget.value))) {
            setInfluencerIds(influencerIds.filter((x) => x !== parseInt(e.currentTarget.value)));
        } else {
            setInfluencerIds([...influencerIds, parseInt(e.currentTarget.value)]);
        }
    };

    const submit = () => {
        setOpen(false);
        query.set("ids", influencerIds.join(","));

        history.replace({
            search: `?${query.toString()}`,
        });
    };

    return (
        <Modal open={open} setOpen={setOpen} className="influencer-modal">
            <ModalBody>
                <p>Select influencers to compare:</p>
                {influencers.length > 0 &&
                    influencers.map((x, i) => (
                        <div className="influencer-item" key={i}>
                            <input type="checkbox" id={`check-influencer-${x.Id}`} value={x.Id} checked={influencerIds.includes(x.Id)} onChange={onChange} disabled={influencerIds.length === 1 && influencerIds[0] === x.Id} />
                            <label htmlFor={`check-influencer-${x.Id}`}>
                                {x.AuthorName} {getStreamIcon(x.StreamId)}
                            </label>
                        </div>
                    ))}
                <button onClick={submit}>
                    <i className="fal fa-check"></i>
                </button>
            </ModalBody>
        </Modal>
    );
}

export default InfluencerModal;
